// extracted by mini-css-extract-plugin
export default {"starsContainer":"Stars_starsContainer__G-nGb","star":"Stars_star__XEZ95","sparkle":"Stars_sparkle__J5+X6"};